import { actionFlags, featureFlags } from "./featureConfig";

const cloneActionFlags = (source) => Object.fromEntries(
  Object.entries(source).map(([group, actions]) => [group, { ...actions }])
);

export const defaultFeatureFlags = { ...featureFlags };

export const defaultActionFlags = cloneActionFlags(actionFlags);

export const defaultTableActions = defaultActionFlags;

export function createDefaultPermissionProfile() {
  return {
    featureFlags: Object.fromEntries(
      Object.keys(defaultFeatureFlags).map((key) => [key, false])
    ),
    actionFlags: Object.fromEntries(
      Object.entries(defaultActionFlags).map(([group, actions]) => [
        group,
        Object.fromEntries(Object.keys(actions).map((action) => [action, false])),
      ])
    ),
  };
}
